<template>
  <div class="filter-box">
    <div>
      <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">全选</a-checkbox>
      <a-divider style="margin:8px 0;" />
      <a-checkbox-group v-model="checkedList" :options="options" @change="onChange" />
    </div>
    <a-divider style="margin:8px 0;" />
    <div>
      <a-button type="primary" size="small" @click="handleOk">确认</a-button>
      <a-button size="small" class="ml-8" @click="handleReset">取消</a-button>
    </div>
  </div>
</template>

<script>
import isEqual from 'lodash.isequal'

export default {
  name: 'CustomTableFilter',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    resetFlag: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    resetFlag () {
      this.handleClear()
    }
  },
  data () {
    return {
      checkedList: [],
      oriCheckedList: [],
      indeterminate: false,
      checkAll: false
    }
  },
  methods: {
    onChange (checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.options.length
      this.checkAll = checkedList.length === this.options.length
    },
    onCheckAllChange (e) {
      Object.assign(this, {
        checkedList: e.target.checked ? this.options.map(item => Object.prototype.toString.call(item) === '[object Object]' ? item.value : item) : [],
        indeterminate: false,
        checkAll: e.target.checked
      })
    },
    // 确定按钮，传递选择项并刷新列表
    handleOk () {
      this.$emit('update', this.checkedList) // update是改变 filtered 的状态
      this.$emit('filter', this.checkedList) // filter 才会发送loadData请求
      this.oriCheckedList = this.checkedList
    },
    // 重置按钮，清空选择并刷新列表
    handleReset () {
      this.checkedList = []
      this.onChange(this.checkedList)
      this.$emit('update', this.checkedList)
      this.oriCheckedList = this.checkedList
      this.$emit('filter', this.checkedList)
    },
    // filter消失时触发，如果没有点击确定，所做的更改就不会生效
    handleHide () {
      if (!isEqual(this.oriCheckedList, this.checkedList)) {
        this.checkedList = this.oriCheckedList
        this.onChange(this.checkedList)
      }
    },
    // 整张表重置，会清空全部选择，和 handleReset 的区别是不会刷新列表
    handleClear () {
      this.checkedList = []
      this.oriCheckedList = []
      this.onChange(this.checkedList)
      this.$emit('update', this.checkedList)
    }
  }
}
</script>
<style lang="less" scoped>
.filter-box{
  padding: 12px;
}
/deep/.ant-checkbox-group label{
  display: block;
}
</style>
